var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 520 520",
    height: 512,
    viewBox: "0 0 520 520",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m215 335h90v70h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275 280c0-8.271-6.729-15-15-15s-15 6.729-15 15v25h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 125.016h-206.597l-56.861-92.85c-2.727-4.452-7.571-7.166-12.792-7.166h-153.75c-24.813 0-45 20.187-45 45v380c0 24.813 20.187 45 45 45h430c24.813 0 45-20.187 45-45v-279.984c0-24.814-20.187-45-45-45zm-140 294.984c0 8.284-6.716 15-15 15h-120c-8.284 0-15-6.716-15-15v-100c0-8.284 6.716-15 15-15h15v-25c0-24.813 20.187-45 45-45s45 20.187 45 45v25h15c8.284 0 15 6.716 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 95.016v-5.016c0-24.813-20.187-45-45-45h-175.42l30.63 50.016z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7757871fdf4becabe1a404b600bb3123.svg";
export { ForwardRef as ReactComponent };